import { ANIMATION_DURATION_IN_MILLIS } from "components/Message/configs";
import { useMessageContext } from "providers/MessageProvider";
import React, { useEffect, useState } from "react";
import Solution from "./Solution";
import { Container, StyledSuccess } from "./styles";

const Prompt = React.forwardRef<HTMLDivElement>((_, ref) => {
  const { isFormSuccessVisible, isFormVisible } = useMessageContext();
  const [displaySuccess, setDisplaySuccess] = useState(false);

  useEffect(() => {
    if (isFormSuccessVisible) {
      setDisplaySuccess(true);
      return;
    }

    setTimeout(() => {
      setDisplaySuccess(false);
    }, ANIMATION_DURATION_IN_MILLIS);
  }, [isFormSuccessVisible]);

  return (
    <Container ref={ref} isFormVisible={isFormVisible}>
      <Solution />
      {displaySuccess && <StyledSuccess isVisible={isFormSuccessVisible} />}
    </Container>
  );
});

export default Prompt;
